import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { createForm, renderField } from './utils';

const OtherInfoForm = () => (
  <div>
    <Row>
      <Col sm={6}>{renderField('RegulatoryStatus')}</Col>
      <Col sm={6}>{renderField('PivotValue')}</Col>
    </Row>
    <Row>
      <Col sm={6}>{renderField('SkinPenetration')}</Col>
    </Row>
  </div>
);

export default createForm(OtherInfoForm);
